import { render, staticRenderFns } from "./dealer.vue?vue&type=template&id=4de219c4&"
import script from "./dealer.vue?vue&type=script&lang=js&"
export * from "./dealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports